import axios from "axios"
import { config } from "@/config"
import { DateTime } from 'luxon'

class Logger {
    webhook = config.slack.webhook;

    constructor() {

    }

    private getCurrentDateTime = () => {
        let date = DateTime.now().setZone('UTC+7').toFormat('dd/MM/yyyy HH:mm:ss');
        return date
    }

    private logPattern = (level: any, location: any, message: any) => {
        let dateTime = this.getCurrentDateTime()
        let pattern = `[${dateTime}] - [${level}] - [${location}] - [${message}]`
        return pattern
    }

    private sendLog = async (level: string, location: any, message: string) => {
        try {
            message = JSON.stringify(message)
            let log = this.logPattern(level, location, message)
            let data = await axios.post(this.webhook, JSON.stringify({ text: log }),
                {
                    withCredentials: false,
                    transformRequest: [
                        (data, headers) => {
                            return data
                        }
                    ]
                }
            )
        } catch (error) {

        }
    }

    public debug = async (location: string, message: string) => {
        await this.sendLog('DEBUG', location, message)
    }

    public info = async (location: any, message: any) => {
        await this.sendLog('INFO', location, message)
    }

    public error = async (location: string, message: string) => {
        await this.sendLog('ERROR', location, message)
    }

    public warn = async (location: any, message: any) => {
        await this.sendLog('WARN', location, message)
    }

    public critical = async (location: any, message: any) => {
        await this.sendLog('CRITICAL', location, message)
    }
}

export default Logger